import { gql } from "@apollo/client";

export const CREATE_PLACEMENT = gql`
  mutation CreatePlacement($input: createPlacementInput) {
    createPlacement(input: $input) {
      placementId
    }
  }
`;


export const UPDATE_PLACEMENT = gql`
  mutation UpdatePlacement($input: updatePlacementInput) {
    updatePlacement(input: $input)
  }
`;

export const GET_PLACEMENT_BY_ORG = gql`
  query placementByOrg($orgId: Int) {
    placementByOrg(orgId: $orgId) {
      placementId
      client
      applicantId
      jobId
      recruiter
      joiningDate
      position
      billedAmount
      ctc
      employmentType
      revenueType
      totalRevenue
      orgId
      createdAt
      joiningStatus
      applicantName
      invoiceDetails {
        inVoiceId
      }
      clientDetails {
        name
        clientId
      }
      readByUser
      recruiterDetails {
        firstName
        lastName
        reportTo
        reportToDetails {
          reportTo
        }
        department
      }
      jobDetails {
        jobTitle
        jobId
      }
    }
  }
`;




